"use client";

import NextImage, { type ImageProps } from "next/image";
import { isMzstaticThumb, mzstaticLoader } from "@/lib/mzstatic-image";

/** next/image, except Apple CDN thumbs are sized by Apple's URL instead of Vercel Image Optimization. */
export default function Image(props: ImageProps) {
  const { src, loader } = props;
  const mz = !loader && typeof src === "string" && isMzstaticThumb(src);
  return <NextImage {...props} alt={props.alt} loader={mz ? mzstaticLoader : loader} />;
}
